import { Component } from '@angular/core';
import { IFloatingFilterAngularComp } from '@ag-grid-community/angular';
import { NotificationStatusEnum } from 'shared/constants/notification-statuses';
import { FilterChangedEvent } from '@ag-grid-community/core/dist/esm/es6/events';
import { IFloatingFilterParams } from '@ag-grid-community/core/dist/esm/es6/filter/floating/floatingFilter';

@Component({
    selector: 'app-notification-status-floating-filter',
    templateUrl: './notification-status-floating-filter.component.html',
    styleUrls: ['./notification-status-floating-filter.component.scss'],
    standalone: false,
})
export class NotificationStatusFloatingFilterComponent implements IFloatingFilterAngularComp {
    private params!: IFloatingFilterParams;
    public parentFilter: any;

    agInit(params: IFloatingFilterParams): void {
        this.params = params;
    }

    showParentFilter() {
        this.params.showParentFilter();
    }

    onParentModelChanged(parentModel: any, filterChangedEvent?: FilterChangedEvent | null): void {
        if (parentModel?.values) {
            parentModel.values = parentModel?.values.sort((a: string, b: string) => {
                const indexA = Object.values(NotificationStatusEnum).findIndex((elem) => elem == a);
                const indexB = Object.values(NotificationStatusEnum).findIndex((elem) => elem == b);

                if (indexA < indexB) {
                    return -1;
                }
                if (indexA > indexB) {
                    return 1;
                }

                return 0;
            });
        }
        this.parentFilter = parentModel;
    }
}
